import Box from '@mui/material/Box';
import { GradientTypography } from '../gradients/GradientTypography';
import { AuthenticationBackButton } from './AuthenticationBackButton';
import { AuthenticationCloseButton } from './AuthenticationCloseButton';

type AuthenticationNavbarProps = {
  goBack: () => void;
  closeModal: () => void;
  prevPageId?: string;
};

export function AuthenticationNavbar({
  goBack,
  closeModal,
  prevPageId,
}: AuthenticationNavbarProps) {
  if (!closeModal) return null;

  return (
    <Box display={'flex'} flexDirection={'row'} width={'100%'}>
      {!!goBack && !!prevPageId && (
        <Box
          flexGrow={1}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          sx={{
            ml: 2,
          }}
        >
          <Box>
            <AuthenticationBackButton goBack={goBack} />
          </Box>
          <Box ml={'4px'}>
            <GradientTypography
              variant="h5"
              gradientColor="primary.vertical"
              textTransform="uppercase"
            >
              Back To{' '}
              {prevPageId === 'registration start'
                ? 'sign in options'
                : prevPageId}
            </GradientTypography>
          </Box>
        </Box>
      )}
      <Box ml={'auto'} mr={2}>
        <AuthenticationCloseButton
          closeModal={closeModal}
          forAuthNavbar={true}
        />
      </Box>
    </Box>
  );
}
